import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const toastStyle = {
  background: '#1E0039',
  color: '#ffffff',
  border: '1px solid #712CB0',
  boxShadow: '0 0 12px #712CB0',
  borderRadius: '8px',
  fontFamily: 'inherit',
  fontSize: '0.8rem',
  padding: '10px 14px',
  minHeight: 'unset',
};

const toastProgressStyle = {
  background: 'linear-gradient(to right, #712CB0, #a855f7)',
};

export default function KinoToastContainer() {
  return (
    <ToastContainer
      position="top-center"
      autoClose={3000}
      toastStyle={toastStyle}
      toastClassName="kino-toast"
      progressStyle={toastProgressStyle}
      closeButton={false}
      // Above every modal and popover (the highest app layer is tw-z-[10000]).
      style={{ '--toastify-z-index': 10001 }}
    />
  );
}